import { useNavigate } from 'react-router-dom';

/* eslint-disable no-unused-vars */
interface MenuItemProps {
  href: string;
  property1: string;
  property2?: string;
  isActive: boolean;
  setIsMenuOpen?: (open: boolean) => void;
  icon?: React.ReactNode;
}

export const MenuItem = (props: MenuItemProps) => {
  const navigate = useNavigate();
  const { href, property1, property2, isActive, setIsMenuOpen, icon } = props;
  return (
    <button
      onClick={() => {
        navigate(href);
        setIsMenuOpen?.(false);
      }}
      className={`w-auto h-[44px] px-[16px] py-[12px] flex items-center gap-[8px] rounded-tl-[4px] text-white transition 
        ${isActive ? 'opacity-100' : 'opacity-75 hover:opacity-100'}`}
    >
      {icon}
      <div className="flex flex-col">
        <span>{property1}</span>
        {property2 && (
          <span className="text-gray-400 text-sm">{property2}</span>
        )}
      </div>
    </button>
  );
};
